var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.editable)?_c('vue-dropzone',{ref:"myVueDropzone",attrs:{"id":"dropzone","options":_vm.dropzoneOptions},on:{"vdropzone-removed-file":_vm.removeThisFile,"vdropzone-complete":_vm.fileUploaded,"vdropzone-file-added":_vm.update_cookie}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }